<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" @click="close">
      <div class="modal" @click.stop="">
        <header class="modal-header">
          <slot name="header" class="textCenter">
            Default Title
          </slot>
        </header>

        <section class="modal-body">
          <slot name="body">
            Default body
          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            <div style="display: flex;">
                <a class="mar10r mar10l primary-color">ذخیره</a>
                <a class="mar10r mar10l" @click="close">لغو</a>
            </div>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    name: 'Modal',
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style scoped>

  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 0 2px 5px #0000006b;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    text-align: right;
    margin: 70px 0;
    direction: rtl;
    max-width: 370px;
    position: relative;
    width: 100%;
  }

  .modal-header,
  .modal-footer {
    padding: 10px;
    display: flex;
  }

  .modal-header {
    justify-content: space-between;
    position: relative;
    border-bottom: 1px solid #002664;
    color: #000;
    margin: 0 auto;
    width: 90%;
    display: block;
    font-size: 16px;
    text-align: center;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 100;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
    flex-direction: column;
  }

  .modal-body {
    position: relative;
    padding: 20px 20px 45px;
    width: 100%;
  }

  .modal-tital{
    text-align: center;
    font-size: 18px;
    font-weight: normal;
    border-bottom: #0b46c4 1px solid;
    margin: 0 0 5px;
    padding: 0 0 5px;
  }

  .modal-tital.orang{
    border-bottom: #ccc 1px solid;
  }

  .btn-close {
    position: absolute;
    top: 0;
    left: 0;
    border: none;
    font-size: 14px;
    padding: 1px 5px;
    cursor: pointer;
    font-weight: bold;
    color: #fb5151;
    font-family: cursive;
    border-radius: 50%;
    box-shadow: 0 0 5px #00000033;
    margin: 20px;
    background: #ffffff;
  }
      
  a:hover{
      cursor: pointer;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>
